import { render, staticRenderFns } from "./setBuilding.vue?vue&type=template&id=68387292&scoped=true&"
import script from "./setBuilding.vue?vue&type=script&lang=js&"
export * from "./setBuilding.vue?vue&type=script&lang=js&"
import style0 from "./setBuilding.vue?vue&type=style&index=0&id=68387292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68387292",
  null
  
)

export default component.exports